import { useQuery } from "@tanstack/react-query";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import ArticleCard from "@/components/ArticleCard";

export default function TagArchive() {
  const { slug } = useParams();
  const { data: articles = [], isLoading } = useQuery({
    queryKey: ["tag-articles", slug],
    queryFn: () => api.get("/articles", { params: { tag: slug } }).then((r) => r.data),
  });

  return (
    <div className="mx-auto max-w-6xl px-5 sm:px-8 pt-12">
      <span className="text-xs font-semibold uppercase tracking-widest text-brand-clay">Topic</span>
      <h1 className="mt-3 font-heading text-4xl sm:text-5xl text-brand-ink tracking-tight">#{slug}</h1>

      {isLoading ? (
        <p className="mt-16 text-center text-brand-muted">Loading…</p>
      ) : articles.length === 0 ? (
        <div className="mt-16 text-center text-brand-muted">
          No articles under this topic yet. <Link to="/articles" className="text-brand underline">Browse all</Link>
        </div>
      ) : (
        <div className="mt-10 grid gap-7 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((a, i) => (
            <ArticleCard key={a.slug} article={a} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
